import { calcSwitchContext, visibleSwitches } from '@aytm/app/stats/page/sidebar/components/lib/switches'

export const OPEN_SIDEBAR_LINK_NAME = 'open-sidebar'

export const CROSSTAB_SIDEBAR_TAB = 'crosstab-panel'

// Read off the same gate the switch strip draws from rather than off the drawn strip: a comment is
// parsed once, and one parsed before the strip mounts would keep its link inert for good.
export function checkSidebarLink({ tab }: { tab: string }) {
  if (!tab) return false
  const model = StatPage?.model
  if (!model?.features) return false
  const tabTitle = CROSSTAB_SIDEBAR_TAB == tab ? 'export' : tab.replace('-panel', '')
  const ctx = calcSwitchContext({
    features: model.features,
    isReportVirtual: model.isReportVirtual?.() || false,
    isReportXpert: model.isReportXpert?.() || false
  })
  return visibleSwitches(ctx).some(item => tabTitle == item.panel)
}

export default function openSidebarLink({ tab, focus }: { tab: string; focus: string }) {
  if (tab) {
    const tabTitle = CROSSTAB_SIDEBAR_TAB == tab ? 'export' : tab.replace('-panel', '')
    const res = StatPage?.sidebar?.onPanelChange?.(tabTitle)
    if (CROSSTAB_SIDEBAR_TAB == tab) StatPage?.sidebar?.updateSidebarState?.('export', { exportType: 'crosstab' })
    if (false == res) return
  }
  if (focus) {
    switch (focus) {
      case 'add-banner': {
        const focusOn = async () => {
          try {
            const addBannerDropdown: HTMLElement = await waitForSelector('#stat-exports-crosstab-add-banner-selector')
            addBannerDropdown?.click()
            const filterInput = await waitForSelector('.p-dropdown-filter', addBannerDropdown)
            filterInput?.focus()
          } catch {
            // skip
          }
        }
        void focusOn()
        break
      }
      case 'confidence-level': {
        const focusOn = async () => {
          try {
            const confidenceLevelDropdown: HTMLElement = await waitForSelector(
              '#stat-exports-crosstab-confidence-level'
            )
            if (confidenceLevelDropdown) {
              const trigger = await waitForSelector('.p-dropdown-trigger', confidenceLevelDropdown)
              await focusBlink(trigger)
              trigger.focus()
            }
          } catch {
            // skip
          }
        }
        void focusOn()
        break
      }
      case 'significance-level': {
        const focusOn = async () => {
          try {
            const significanceLevelDropdown: HTMLElement = await waitForSelector(
              '#stat-exports-crosstab-significance-level'
            )
            if (significanceLevelDropdown) {
              const trigger = await waitForSelector('.p-dropdown-trigger', significanceLevelDropdown)
              await focusBlink(trigger)
              trigger.focus()
            }
          } catch {
            // skip
          }
        }
        void focusOn()
        break
      }
      default: {
        break
      }
    }
  }
}

function waitForSelector(selector: string, parent: ParentNode = document, retries = 20): Promise<HTMLElement> {
  let retriesLeft = retries
  return new Promise((resolve, reject) => {
    const interval = setInterval(() => {
      const element = parent.querySelector(selector)
      if (element) {
        clearInterval(interval)
        resolve(element as HTMLElement)
      }
      retriesLeft--
      if (retriesLeft <= 0) {
        clearInterval(interval)
        reject()
      }
    }, 100)
  })
}

async function focusBlink(element: HTMLElement, stepDuration = 150, times = 3): Promise<void> {
  const waitTime = (resolve: (v: unknown) => void) => setTimeout(resolve, stepDuration)
  const blink = async () => {
    element.focus()
    await new Promise(waitTime)
    element.blur()
    await new Promise(waitTime)
  }
  for (let i = 0; i < times; i++) {
    await blink()
  }
}
